import React, { useEffect, useState } from "react";
import "./FeaturesPop.css";
import { RxCross1 } from "react-icons/rx";
import FastImage from "../../../../FastImage";
import { auto } from "@patternfly/react-core/dist/esm/helpers/Popper/thirdparty/popper-core";
import { IoIosArrowUp } from "react-icons/io";
import { IoIosArrowDown } from "react-icons/io";

import { IoLocationSharp } from "react-icons/io5";
import ProgressStepper from "../ProgressStepper";
import { MdHealthAndSafety } from "react-icons/md";

import { MdLocalHospital } from "react-icons/md";

import { FaQuestionCircle } from "react-icons/fa";
import { VscRunAllCoverage } from "react-icons/vsc";

const FeaturesPop = ({ popOpen, setPopOpen }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [clickedIndex, setClickedIndex] = useState(0); // Features button clicked by default
  const [selectedIndex, setSelectedIndex] = useState(0); // First service button clicked by default
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [activeIndex, setActiveIndex] = useState(null);

  const handleToggle = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  const handleClick = (index) => {
    setSelectedIndex(index);
  };

  const handleButtonClick = (index) => {
    // Set the clickedIndex to the clicked button's index
    setClickedIndex(index);
  };

  const togglePanel = () => {
    setIsOpen(!isOpen);
    setPopOpen(!isOpen);
  };

  useEffect(() => {
    setIsOpen(popOpen);
  }, []);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  const questionsAnswers = [
    {
      question: "What is React?",
      answer: "React is a JavaScript library for building user interfaces.",
    },
    {
      question: "What is a component?",
      answer:
        "Components let you split the UI into independent, reusable pieces, and think about each piece in isolation.",
    },
    {
      question: "What is state in React?",
      answer:
        "State is a built-in object that allows you to store property values that belong to a component.",
    },
  ];

  const toggleAnswer = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const buttons = ["Features", "Cashless Hospitals", "FAQ", "Claims"];

  const CoverData = [
    {
      id: 0,
      name: "Lorem Ipsum has been the industry's",
      description:
        "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    {
      id: 1,
      name: "Lorem Ipsum has been the industry's ,",
      description:
        "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    {
      id: 2,
      name: "Lorem Ipsum has been the industry's ",
      description:
        "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    {
      id: 3,
      name: "Lorem Ipsum has been the industry's ",
      description:
        "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    {
      id: 4,
      name: "Lorem Ipsum has been the industry's ",
      description:
        "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
    {
      id: 5,
      name: "Lorem Ipsum has been the industry's ,",
      description:
        "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    },
  ];
  const services = [
    {
      id: 0,
      name: "Coverage",
      content: (
        <>
          <h3>What your plan Covers</h3>
          <hr />
          {CoverData.map((item, index) => (
            <div key={index} className="feature-question-item">
              <div
                // className="feature-question"
                onClick={() => handleToggle(index)}
                className={`feature-question ${
                  expandedIndex === index ? "active-question" : ""
                }`}
              >
                <div className="right-img-panel-div">
                  {/* <FastImage
                    className="right-img-panel"
                    url="Website%20Img/right.png?updatedAt=1719487210487"
                    width="auto"
                    height="auto"
                    alt="right-logo"
                    src="Website%20Img/right.png?updatedAt=1719487210487"
                  /> */}
                  <h3>{item.name}</h3>
                  <span
                    className={`arrow ${expandedIndex === index ? "open" : ""}`}
                  >
                    {expandedIndex === index ? (
                      <IoIosArrowUp />
                    ) : (
                      <IoIosArrowDown />
                    )}
                  </span>
                </div>
              </div>
              <div
                className={`feature-answer ${
                  expandedIndex === index ? "active" : ""
                }`}
              >
                <div className="expanded-content">
                  <ul className="expanded-ul">
                    <li className="right-img-panel-p">{item.description}</li>
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </>
      ),
    },
    {
      id: 1,
      name: "Value added services",
      content: (
        <div>
          <h3>Value added services</h3>
          <p>Details about value added services...</p>
        </div>
      ),
    },
    {
      id: 2,
      name: "Waiting periods",
      content: (
        <div>
          <h3>Waiting periods</h3>
          <p>Details about waiting periods...</p>
        </div>
      ),
    },
    {
      id: 3,
      name: "Additional features",
      content: (
        <div>
          <h3>Additional features</h3>
          <p>Details about additional features...</p>
        </div>
      ),
    },
    {
      id: 4,
      name: "Maternity Benefits",
      content: (
        <div>
          <h3>Maternity Benefits</h3>
          <p>Details about maternity benefits...</p>
        </div>
      ),
    },
    {
      id: 5,
      name: "Policy Documents",
      content: (
        <div>
          <h3>Policy Documents</h3>
          <p>Details about policy documents...</p>
        </div>
      ),
    },
  ];

  const jsonData = [
    {
      image: "Website%20Img/red-cross_185941.png?updatedAt=1720070634396",
      alt: "hospital image 1",
      name: "Suri Municipality Hospital",
      address:
        "Suri Sadar Hospital Road, Sabuj Pally, Suri, Birbhum District, West Bengal, India",
    },
    {
      image: "Website%20Img/red-cross_185941.png?updatedAt=1720070634396",
      alt: "hospital image 2",
      name: "Another Hospital",
      address: "Hospital Address, City, State, Country",
    },
    {
      image: "Website%20Img/red-cross_185941.png?updatedAt=1720070634396",
      alt: "hospital image 3",
      name: "Third Hospital",
      address: "Third Hospital Address, City, State, Country",
    },
  ];

  return (
    <>
      {isOpen && <div className="modal-backdrop" onClick={togglePanel}></div>}
      <div className={`slide-in-panel ${isOpen ? "open" : ""}`}>
        <div className="panel-content">
          <div className="panel-heading">
            <h3>Explore Your Plan</h3>

            <button className="toggle-button" onClick={togglePanel}>
              <RxCross1 />
            </button>
          </div>
          <div className="panel-body">
            <div className="panel-plan-detail">
              <div className="plan-description">
                <div className="panel-plan-img">
                  {/* <FastImage
                    className={"panel-plan-logo"}
                    url={"Website%20Img/care.png?updatedAt=1718795342791"}
                    width={auto}
                    height={auto}
                    alt={"travel"}
                    src={"Website%20Img/care.png?updatedAt=1718795342791"}
                  /> */}
                </div>
                <div className="plan-para">
                  <h3>Care Supreme Direct</h3>
                  <p>Lorem ipsum dolor sit amet, </p>
                </div>
              </div>
              <div className="plan-cover">
                <h4>Cover Amount :</h4>
                <p>1 Cr</p>
              </div>
            </div>
            <hr className="panel-hr"></hr>
            <div className="panel-lower-body">
              <div className="button-container">
                {buttons.map((text, index) => (
                  <button
                    key={index}
                    className={`toggle-button-panel ${
                      clickedIndex === index ? "clicked" : ""
                    }`}
                    onClick={() => handleButtonClick(index)}
                  >
                    {text}
                  </button>
                ))}
              </div>
              <hr className="panel-sec-hr"></hr>
              {clickedIndex === 0 && (
                <div className="feature-all">
                  {/*--for features section ----------------- */}
                  <div className="panel-lower-options">
                    {services.map((item, index) => (
                      <div
                        key={index}
                        className={`lower-opt ${
                          selectedIndex === index ? "selected" : ""
                        }`}
                        onClick={() => handleClick(index)}
                      >
                        <p>{item.name}</p>
                      </div>
                    ))}
                  </div>

                  {/* ------------------ feature -> all options lower--------------------- */}
                  <div className="cover-question">
                    {services[selectedIndex].content}
                  </div>
                </div>
              )}
              {clickedIndex === 1 && (
                <div className="cashless-all">
                  {/* Content for Cashless Hospitals */}
                  <h3 className="cashless-heading">
                    Now Enjoy having Cashless Treatment Anywhere !{" "}
                  </h3>

                  <div className="cashless-upper">
                    <div className="cashless-search">
                      <label>
                        Search Hospitals by Locality
                        <div className="cashless-location">
                          <IoLocationSharp className="cashless-location-icon" />
                          <p>Birbhum</p>
                        </div>
                      </label>
                      <input></input>
                    </div>
                  </div>
                  <div className="cashless-lower">
                    <div className="cashless-lower-para">
                      <p>
                        <span>20</span> Cashless hospitals found in your area -{" "}
                      </p>
                      <hr></hr>
                    </div>
                    {/* <div className="cashless-lower-question">
                      <div className="cashless-hospital-name">
                        <FastImage
                          className="cashless-questions"
                          url={
                            "Website%20Img/hospital.png?updatedAt=1719910994531"
                          }
                          width={auto}
                          height={auto}
                          alt={"flag"}
                          src={
                            "Website%20Img/hospital.png?updatedAt=1719910994531"
                          }
                        />
                        <p>Suri Municipality Hospital </p>
                      </div>
                      <div className="cashless-hospital-address">
                        Suri Sadar Hospital Road, Sabuj Pally, Suri, Birbhum
                        District, West Bengal, India
                      </div>
                    </div> */}
                    <div className="cashless-lower-question ">
                      {jsonData.map((item, index) => (
                        <div key={index} className="cashless-hospital col-md-6">
                          <div className="cashless-hospital-name">
                            {/* <FastImage
                              className="cashless-questions"
                              url={item.image}
                              width={auto}
                              height={auto}
                              alt={item.alt}
                              src={item.image}
                            /> */}
                            <p><MdLocalHospital className="cashless-hospital-icon" />{item.name}</p>
                          </div>
                          <div className="cashless-hospital-address">
                            {item.address}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
              {clickedIndex === 2 && (
                <div className="faq-all">
                  {/* Content for FAQ */}
                  <div className="faq-all-header">
                    <h3>Your Questions Are Answered Here </h3>
                    {/* <FastImage
                    className="right-img-panel"
                    url="Website%20Img/interrogation-mark_5271291.png?updatedAt=1720072370543"
                    width="auto"
                    height="auto"
                    alt="right-logo"
                    src="Website%20Img/interrogation-mark_5271291.png?updatedAt=1720072370543"
                  /> */}
                  </div>
                  <hr></hr>
                  <div className="faq-container">
                    {questionsAnswers.map((item, index) => (
                      <div key={index} className="faq-item">
                        <button
                          // className="faq-question"
                          className={`faq-question ${
                            activeIndex === index ? "active-question" : ""
                          }`}
                          onClick={() => toggleAnswer(index)}
                        >
                         <div>
                         {/* <FastImage
                            className="right-img-panel"
                            url="Website%20Img/question_2538036.png?updatedAt=1720073052387"
                            width="auto"
                            height="auto"
                            alt="right-logo"
                            src="Website%20Img/question_2538036.png?updatedAt=1720073052387"
                          /> */}
                          <FaQuestionCircle className="faq-question-feature" />{item.question}
                         </div>
                          <span
                            className={`arrow ${
                              activeIndex === index ? "open" : ""
                            }`}
                          >
                            {activeIndex === index ? (
                              <IoIosArrowUp />
                            ) : (
                              <IoIosArrowDown />
                            )}
                          </span>
                        </button>
                        <div
                          className={`faq-answer ${
                            activeIndex === index ? "active" : ""
                          }`}
                        >
                          {item.answer}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {clickedIndex === 3 && (
                <div className="claims-all">
                  {/* Content for Claims */}
                  {/* <h3>Claims</h3>
                  <p>Details about Claims...</p> */}
                  <ProgressStepper/>
                </div>
              )}

              {/* --for Cashless Hospital ------------------------------------ */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FeaturesPop;
